<script setup>
import { useI18n } from '../../i18n'
import { systemRoleName } from '../../access/labels.js'

defineProps({
  search: { type: String, default: '' },
  roleId: { type: [String, Number], default: '' },
  status: { type: String, default: '' },
  roles: { type: Array, default: () => [] },
})
const emit = defineEmits(['update:search', 'update:roleId', 'update:status', 'apply', 'reset'])
const { t } = useI18n()
</script>

<template>
  <form class="access-filters" role="search" @submit.prevent="emit('apply')">
    <label class="access-search"><span class="sr-only">{{ t('searchUsers') }}</span>
      <input :value="search" type="search" :placeholder="t('searchUsersPlaceholder')" @input="emit('update:search', $event.target.value)" />
    </label>
    <label><span class="sr-only">{{ t('role') }}</span><select :value="roleId" @change="emit('update:roleId', $event.target.value)">
      <option value="">{{ t('allRoles') }}</option><option v-for="role in roles" :key="role.id" :value="role.id">{{ systemRoleName(t, role) }}</option>
    </select></label>
    <label><span class="sr-only">{{ t('status') }}</span><select :value="status" @change="emit('update:status', $event.target.value)">
      <option value="">{{ t('allStatuses') }}</option><option value="enabled">{{ t('activeUsers') }}</option><option value="blocked">{{ t('blockedUsers') }}</option>
    </select></label>
    <button class="button button-secondary" type="submit">{{ t('apply') }}</button>
    <button class="button button-quiet access-reset" type="button" @click="emit('reset')">{{ t('reset') }}</button>
  </form>
</template>
